import React, { Component } from 'react';
import { encodeForURI } from 'appSrc/utils';
import { connect } from 'react-redux';
import { dAPI } from 'appSrc/api';
import { showModal, hideModal } from 'appSrc/redux/actions';
import LoadingReplace from 'appSrc/components/Shards/Loading/LoadingReplace';
import EditProductModal from '../../Modals/Product/EditProductModal';
import { InternalLink, ExternalLink, PrimaryButton, DLRichTextOutput } from 'appSrc/components/UI';
import TagDisplay from 'appSrc/components/Tag/Display';
import NewReviewModal from '../../Modals/Review/NewReviewModal';
import SortableReviewsTable from './ReviewsTable';
import { tdcDomainMatch } from 'appSrc/utils/random';
import style from './styles/style.module.css';

class IndividualProductPage extends Component {
    constructor( props ) {
        super( props );

        this.state = {
            fetching: true,
            product: {},
            showNewReviewModal: false,
        };
        this.loadProduct( this.props.match.params.pid );
    }

    loadProduct = ( desireid ) => {
        this.props.getProduct( desireid )
        .then( ( product ) => {
            this.setState( {
                fetching: false,
                product: product,
            } );
        } );
    }

    openEditModal = () => {
        this.props.showModal( 'editProductModal' );
    }

    onEditSubmit = ( updates ) => {
        var oldProduct = this.state.product;
        var calls = [];
        for( var i = 0; i < updates.tags.newTags.length; i++ ) {
            var tag = updates.tags.newTags[ i ];
            calls.push( this.props.addTagToProduct( oldProduct.desireid, tag.tagtext ) );
        }
        for( var j = 0; j < updates.tags.deletedTags.length; j++ ) {
            var dTag = updates.tags.deletedTags[ j ];
            calls.push( this.props.deleteTagFromProduct( oldProduct.desireid, dTag.tagtext ) );
        }
        return Promise.all( calls )
        .then( () => {
            return this.props.updateProduct( oldProduct.desireid, updates.product );
        } )
        .then( ( updatedProduct ) => {
            this.setState( { product: updatedProduct } );
            return updatedProduct;
        } );
    }

    onEditClose = () => {
        this.props.hideModal( 'editProductModal' );
    }

    onReviewUpdated = ( index, review ) => {
        if( review == null ) {
            this.setState( ( altState ) => {
                altState.product.reviews = altState.product.reviews.slice( 0, index ).concat( altState.product.reviews.slice( index +1 ) );
                return altState;
            } );
        } else {
            this.setState( ( altState ) => {
                altState.product.reviews[ index ] = review;
                altState.product.reviews = altState.product.reviews.slice( 0 );
                return altState;
            } );
        }
    }
    onManualProductSort = ( o, s, data ) => {
        this.setState( ( prevState ) => {
            var movedProduct = prevState.products.splice( data.oldIndex, 1 )[ 0 ];
            prevState.products.splice( data.newIndex, 0, movedProduct );
            prevState.products = prevState.products.slice( 0 );
            var orderedProductIds = prevState.products.map( product => product.desireid );
            this.props.reorderProduct( prevState.product.desireid, orderedProductIds );
            return prevState;
        } );
    }

    openNewReview = () => {
        this.setState( { showNewReviewModal: true } );
    }
    onNewReviewClose = () => {
        this.setState( { showNewReviewModal: false } );
    }
    onNewReviewSubmit = ( values ) => {
        this.setState( ( altState ) => {
            altState.product.reviews.push( values );
            altState.product.reviews = altState.product.reviews.slice( 0 );
            altState.showNewReviewModal = false;
            return altState;
        } );
    }


    render() {
        const { fetching, product } = this.state;
        const urlQuery = Object.decodeURLQuery( this.props.location.search );
        const activeTab = urlQuery.tab || 'reviews';

        if( fetching ) {
            return (
                <section className={ style.individual }>
                    <LoadingReplace />
                </section>
            );
        }

        const author = product.author || {};

        return (
            <section className={ style.individual }>
                <div className={ style.head }>
                    <div className={ style.controls }>
                        <div className={ style.backLink } onClick={ this.props.history.goBack }>Back</div>
                        <div>
                            <PrimaryButton label='Edit Product' onClick={ this.openEditModal } />
                            <PrimaryButton label='Add Review' onClick={ this.openNewReview }
                            style={ { marginLeft: '15px' } } />
                            <ExternalLink target='_blank' to={ `${ tdcDomainMatch() }/products/${ product.desireid }/${ encodeForURI(product.title) }` }
                            style={ { marginLeft: '15px' } }>
                                <PrimaryButton reverse label='Public Page' />
                            </ExternalLink>
                        </div>
                    </div>
                    <div className={ style.individualDetails }>
                        <div className={ style.coverImage }>
                            <img src={ product.image } />
                        </div>
                        <div>
                            <div className={ style.title }>
                                <h2 style={ { marginRight: '15px' } }>{ product.title }</h2>
                            </div>
                            <div className={ style.author }>
                                <p>Created by: <InternalLink to={ `/admin/users/${ author.userid }` }>{ author.displayName }</InternalLink></p>
                            </div>
                            <div className={ style.price }>
                                <p>${ product.price }</p>
                            </div>
                            <div className={ style.description }>
                                <DLRichTextOutput content={ product.description } />
                            </div>
                            <div className={ style.tags }>
                                <TagDisplay tags={ product.tags } multiLine linked={ false } />
                            </div>
                        </div>
                        <div className={ style.tabs }>
                            <InternalLink to={ `${ this.props.location.pathname }?tab=reviews` }
                            className={ style.tabOption }
                            data-active={ activeTab == 'reviews' }>
                                Reviews { `(${ product.reviews.length })` }
                            </InternalLink>
                        </div>
                    </div>
                </div>
                <div className={ style.body }>
                    { activeTab == 'reviews' &&
                        <SortableReviewsTable reviews={ product.reviews }
                        onReviewUpdated={ this.onReviewUpdated } />
                    }
                </div>
                <EditProductModal closeModal={ this.onEditClose }
                onSubmit={ this.onEditSubmit }
                product={ product } />
                { this.state.showNewReviewModal &&
                    <NewReviewModal closeModal={ this.onNewReviewClose }
                    onSubmit={ this.onNewReviewSubmit }
                    product={ product }/>
                }
            </section>
        );
    }
}

const mapDispatchToProps = ( dispatch ) => {
    return {
        showModal: ( modalName ) => {
            dispatch( showModal( modalName ) );
        },
        hideModal: ( modalName ) => {
            dispatch( hideModal( modalName ) );
        },
        getProduct: ( desireid ) => {
            return dAPI.get( `/admin/desires/${ desireid }` );
        },
        updateProduct: ( desireid, data ) => {
            return dAPI.patch( `/admin/desires/${ desireid }`, data );
        },
        addTagToProduct: ( desireid, newTag ) => {
            return dAPI.post( `/desires/${ desireid }/tag`, { tag: newTag } );
        },
        deleteTagFromProduct: ( desireid, tagtext ) => {
            return dAPI.delete( `/desires/${ desireid }/tag/${ tagtext }` );
        },
    };
};

export default connect( null, mapDispatchToProps )( IndividualProductPage );
